module.exports = "/_next/static/images/florida-d082534124673deeb58c2ada5e274858.svg";